// SETTINGS V2 — demo-pass helpers (DEMO_USER_TYPE_SPEC F1/F2).
//
// Pure formatting only. Deliberately holds NO security-relevant defaults: the
// demo session cap is a server value (`GuestPass.sessionCapHours`) and is never
// guessed here — see the SEC note on `GuestPass` in models/guestPassModels.ts.

/** Splits a PIN into two halves so it can be read aloud in chunks (6 → 3+3,
 *  8 → 4+4). Odd/short PINs are returned whole rather than split awkwardly. */
export const groupPin = (pin: string): string[] => {
  const clean = (pin || "").trim();
  if (clean.length < 6 || clean.length % 2 !== 0) return clean ? [clean] : [];
  const half = clean.length / 2;
  return [clean.slice(0, half), clean.slice(half)];
};

/** Whole hours + minutes left until `iso`, as a compact mono string ("23h 40m",
 *  "45m"). Returns "" when the instant has passed or the input is unparseable —
 *  callers render their own "expired" wording for that case. */
export const formatRemaining = (iso: string, from: number = Date.now()): string => {
  if (!iso) return "";
  const target = new Date(iso).getTime();
  if (Number.isNaN(target)) return "";
  const ms = target - from;
  if (ms <= 0) return "";
  const totalMinutes = Math.floor(ms / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
};

/** True when the pass window closes within `thresholdHours` — drives the amber
 *  emphasis on the list + handoff panel. */
export const isClosingSoon = (
  iso: string,
  thresholdHours = 2,
  from: number = Date.now()
): boolean => {
  if (!iso) return false;
  const target = new Date(iso).getTime();
  if (Number.isNaN(target)) return false;
  const ms = target - from;
  return ms > 0 && ms <= thresholdHours * 3600000;
};
